import { useCallback, useMemo } from 'react'
import sensors from 'sa-sdk-javascript'
import { sensorsConfig } from 'config'

export function sensorsInit() {
  sensors.init({
    server_url: sensorsConfig.serverUrl,
    is_track_single_page: true, // 单页面配置，默认开启，若页面中有锚点设计，需要将该配置删除，否则触发锚点会多触发 $pageview 事件
    use_client_time: true,
    send_type: 'beacon',
    heatmap: {
      //是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
      clickmap: 'default',
      //是否开启触达图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
      scroll_notice_map: 'default',
    },
    show_log: sensorsConfig.showLog,
    version: process.env.REACT_APP_SENSORS_VERSION,
  })
  sensors.quick('isReady', function () {
    const user = window.sessionStorage.getItem('user')
    if (user !== null && user !== 'null') {
      sensors.login(JSON.parse(user).uid)
    }
  })
  sensors.quick('autoTrack')
}

interface UserParamsType {
  game_user_id: string
}

export function useSensors() {
  const userParams = useMemo<UserParamsType>(() => {
    return {
      game_user_id: '',
    }
  }, [])
  const user = window.sessionStorage.getItem('user')
  if (user !== null && user !== 'null') {
    userParams.game_user_id = JSON.parse(user).uid
  }
  const sensorsTrack = useCallback(
    (trackName: string, params: object) => {
      // if (window.location.host.includes('yeehagames')) {
      sensors.track(trackName, {
        ...params,
        game_page_version: process.env.REACT_APP_SENSORS_VERSION,
        ...userParams,
      })
      // }
    },
    [userParams]
  )
  return { sensorsTrack }
}
